export const ORDER_STATES = {
  NEW: 'new',
  FULFILLED: 'fulfilled',
  REOPENED: 'reopened',
  PARTIALLY_PAID: 'partially_paid',
  PARTIALLY_REFUNDED: 'partially_refunded',
  CANCELED: 'canceled',
  REFUNDED: 'refunded',
}
